<template>
  <div :class="cn()">
    <div :class="cn('container')">
      <div :class="cn('heading')">
        <h2 :class="cn('title')">{{ settings.title }}</h2>
        <div :class="cn('introduction')" v-html="settings.caption"></div>

        <a
          v-if="settings.button_label && settings.button_url"
          :class="cn('button')"
          :href="settings.button_url"
        >
          {{ settings.button_label }}
        </a>
      </div>

      <HomeSectionSlideshow :settings="{ display: 'default' }" :slides="slides" />
    </div>
  </div>
</template>

<script lang="ts" setup>
import { bem } from '../../utils/classnames'
import HomeSectionSlideshow from './HomeSectionSlideshow.vue'

const cn = bem('home-section-bespoke')

type BespokeSlide = {
  image_alt: string
  image_url: string
  link_title: string
  title: string
  subtitle: string
  link_url: string
}

defineProps<{
  settings: {
    title: string
    caption: string
    button_label: string
    button_url: string
  }
  slides: BespokeSlide[]
}>()
</script>

<style lang="scss">
@import '~styles/base.scss';

.home-section-bespoke {
  .home-section-slideshow {
    &--default {
      display: flex;
      justify-items: center;
      padding-top: 24px;
      padding-bottom: 0;

      @include breakpoint('l') {
        @include wrapper;
        margin-left: 0 !important;
      }

      .home-section-slideshow {
        &__inner {
          position: relative;
          margin: 0 auto;

          @include breakpoint('l+') {
            width: columns(10);
          }
        }
      }
    }
  }
}

.home-section-bespoke {
  .home-section-slideshow--default {
    padding-top: 24px !important;

    @include breakpoint('l') {
      padding-top: 12px !important;
    }
  }
}

.home-section-bespoke {
  width: 100%;
  padding-top: var(--home-section-padding-default);
  padding-bottom: var(--home-section-padding-default);

  &__container {
    @include wrapper;
  }

  &__heading {
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  &__title {
    @include display-m-light;
  }

  &__introduction {
    margin: 0 auto;
    line-height: 14px;

    @include breakpoint('l+') {
      width: columns(12, -1);
    }
  }

  &__button {
    @include type-xs-uppercase;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    width: columns(6);
    padding: 10px 16px;
    background: black;
    color: white;
    text-decoration: none;
    margin-top: 8px;

    @include breakpoint('l') {
      min-width: 0;
      width: -webkit-fill-available;
      margin-top: 16px;
    }
  }

  :deep(.home-section-slideshow--default) {
    padding-top: 24px;
    padding-bottom: 0;
  }
}
</style>
